import React, {Fragment, useEffect, useState} from "react";
import {Container, Typography, Grid} from "@mui/material";
import CardTripAccordion from "../components/Availability/CardTripAccordion.js";
import {useLocation} from "react-router-dom";
import {registerFindTrip, newRequestApi} from "../utils/utils.js";
import useInfiniteScroll from "../components/Availability/useInfiniteScroll.js";
import {useIsAuthenticated} from "react-auth-kit";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes.js";
import CardTripAccordionLoader from "../components/Availability/CardTripAccordionLoader.js";

import SearchFilterAccordion from "../components/Availability/SearchFilterAccordeon.js";
import ObserverDimensions from "../components/ObserverDimensions";

const DealerAvailabilityPage = () => {
	const [searchForm, setSearchForm] = useState({
		destination: "",
		destinationId: '',
		adventure: "",
		location: "",
		year: "",
		month: "",
		space: "",
		hideUnavailable: true,
		onlyDealerTrips:false,
	});
	const [destinations, setDestinations] = useState([]);
	const [destinationsFilter, setDestinationsFilter] = useState([]);
	const [adventures, setAdventures] = useState([]);
	const [ships, setShips] = useState([]);
	const [paginator, setPaginator] = useState({
		page: 1,
		query: {},
		lastPage: 1,
	});
	const {search} = useLocation();
	const searchParams = new URLSearchParams(search);
	const [showFilters, setShowFilters] = useState(true);
	// const [onlyDealerTrips,setOnlyDealerTrips] = useState(false);
	// const [isFetching, setIsFetching] = useInfiniteScroll(loadMoreData);
	useEffect( ()=> {
		if (searchParams.has('showFilters')) {
			const showFiltersValue = searchParams.get('showFilters');
			// Convertir el valor a booleano
			setShowFilters(showFiltersValue === '1');
		}
		searchParams.delete('showFilters');
	},[searchParams.showFilters]);
	useEffect( ()=> {
		if (searchParams.has('onlyDealerTrips')) {
			const onlyDealerTripsVal = searchParams.get('onlyDealerTrips');
			// Convertir el valor a booleano
			setSearchForm({...searchForm,['onlyDealerTrips']:onlyDealerTripsVal === '1'});
		}
		searchParams.delete('onlyDealerTrips');
	},[searchParams.onlyDealerTrips]);

    useEffect(() => {
        const fetchData = async () => {
            await getDestinations();
            await fetchAdventures();
            await fetchShips();
            registerFindTrip();
        };

        fetchData();
    }, []);

    const getDestinations = async (params = {}) => {
        const filteredKeys = Object.keys(params).filter(k => params[k]);
        const filteredParams = {};

        for (const [key, value] of searchParams) {
			if(key==='apiKey'){
				if(localStorage.getItem('apiKey')!==value)
					await localStorage.setItem('apiKey',value);
			}
			else
            	filteredParams[key] = value;
        }

        // Overwrite query params with select if any
        for (let key of filteredKeys) {
            filteredParams[key] = params[key];

        }

        const preloader = false;
        let page = 1;
        let query = {...filteredParams, page};
        const {data} = await newRequestApi("get-destination-list", "GET", query, null, preloader);
        if (data.status === "success") {
            setDestinations(data.data);
            setDestinationsFilter(data.data);
            setPaginator({...paginator, page, query});
        }
    };

    const fetchAdventures = async (preloader = false) => {
        const {data} = await newRequestApi('get-adventures', "GET", null, null, preloader);
        if (data.status === 'success')
            setAdventures(data.data);
    };

    const fetchShips = async (preloader = false) => {
        const {data} = await newRequestApi("get-ships", "GET", null, null, preloader);
        if (data.status === "success") setShips(data.data);
    };




	return (
		<>
			<Container maxWidth="lg" sx={{ paddingTop: 4}}>
				<Grid container spacing={4} sx={{ px: { xs: '1.6rem', lg: '0' }}}>
					<Grid
						item
						xs={12}
						order={{ xs: 2 }}
						sx={{ marginTop: 0 }}
					>
						{destinationsFilter.length > 0 ?
							destinationsFilter.map((d) => (
								d.destinations.length>0 && d.destinations.map((dd) => (
									<CardTripAccordion
										key={dd.tripClassId}
										destinationId={d.id}
										tripClass={dd}
										searchForm={searchForm}
									/>
								))
							)) :
							<Fragment>
								<CardTripAccordionLoader preloaderIcon />
								<CardTripAccordionLoader preloaderIcon />
								<CardTripAccordionLoader preloaderIcon />
							</Fragment>
						}
					</Grid>
					{ showFilters && <Grid
						item
						xs={12}
						order={{ xs: 1}}
						style={{
							paddingBottom: 50,
							"@media (maxWidth: 1024px)": {
								paddingBottom: 0,
							},
						}}
					>
						<SearchFilterAccordion
							searchForm={searchForm}
							setSearchForm={setSearchForm}
							destinations={destinations}
							adventures={adventures}
							ships={ships}
							setShowFilters={setShowFilters}
							showFilters={showFilters}
							// onlyDealerTrips={onlyDealerTrips}
							// setOnlyDealerTrips={setOnlyDealerTrips}
						/>
					</Grid>}
				</Grid>
			</Container>
			<ObserverDimensions/>
		</>
	);
};

export default DealerAvailabilityPage;

DealerAvailabilityPage.propTypes = {
	trip: TripPropTypes,
};